import { render, staticRenderFns } from "./StepReview.vue?vue&type=template&id=261afbc2&scoped=true"
import script from "./StepReview.vue?vue&type=script&lang=js"
export * from "./StepReview.vue?vue&type=script&lang=js"
import style0 from "./StepReview.vue?vue&type=style&index=0&id=261afbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261afbc2",
  null
  
)

export default component.exports